import type { ReactNode } from 'react';
import type { Author } from '@/api/types';
import { EntityAutocomplete } from './EntityAutocomplete';
import { searchAuthors, createAuthor } from '@/api/authors';

export interface AuthorAutocompleteProps {
  value: Author | null;
  onChange: (value: Author | null) => void;
  label?: string;
  disabled?: boolean;
  allowCreate?: boolean;
  /** Не создавать автора в БД при выборе «Создать» — запись при сохранении формы */
  deferCreate?: boolean;
  error?: boolean;
  helperText?: string;
}

export function AuthorAutocomplete({
  value,
  onChange,
  label = 'Автор',
  disabled = false,
  allowCreate = true,
  deferCreate = false,
  error = false,
  helperText,
}: AuthorAutocompleteProps): ReactNode {
  return (
    <EntityAutocomplete
      value={value}
      onChange={onChange}
      label={label}
      disabled={disabled}
      allowCreate={allowCreate}
      deferCreate={deferCreate}
      error={error}
      helperText={helperText}
      searchFunction={searchAuthors}
      createFunction={createAuthor}
    />
  );
}
